// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import TableCard from "../../../components/tablecard/TableCard";
import Loading from "../../../components/loading/Loading";

import {
    getJobRequestAllTransaksi,
    jobRequestTransaksiSelector
} from '../../hrd/transaksi/job-request/jobRequestTransaksiSlice';


import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const JobRequestOperasionalPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const jobRequest = useSelector(
        jobRequestTransaksiSelector
    );


    useEffect(() => {
        dispatch(getJobRequestAllTransaksi({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && jobRequest.isGetAllSuccess && !jobRequest.isGetFetching) {
            let calc = jobRequest?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jobRequest.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && jobRequest.isGetAllSuccess && !jobRequest.isGetFetching) {
            let calc = jobRequest?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jobRequest.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!jobRequest?.isGetFetching && jobRequest.isGetAllSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = jobRequest?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = jobRequest.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            dispatch(getJobRequestAllTransaksi({
                start: start,
                count: count,
                search: search,
            }));
        }

        setFirstLoading(true);

    });


    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getJobRequestAllTransaksi(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getJobRequestAllTransaksi(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (jobRequest.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? jobRequest.count : newCount,
            search: search,
        }
        dispatch(getJobRequestAllTransaksi(params));

        setPage(1);
        setCount((newCount === "-1") ? jobRequest.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }


    if (!firstLoading && !Array.isArray(jobRequest.data)) {
        return <Loading/>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                primaryID="JRID"
                                editEnabled={false}
                                addButton={false}
                                monitoringJR={true}
                                handleSearch={handleSearch}
                                searchPlaceholder="JobRequest"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Job Request"
                                tableData={jobRequest.data}
                                colOneTitle="No. Quotation"
                                colOneData="QuatationNo"
                                colThreeTitle="No. SPK"
                                colThreeData="SPKNo"
                                colFourTitle="Prioritas"
                                colFourData="Priority"
                                colFiveTitle="Tanggal Prioritas"
                                colFiveData="DateKet"
                                colSevenTitle="Tanggal Input"
                                colSevenData="CreateDate"
                                colEightTitle="Aktifitas"
                                colEightData="ActivityChoice"
                                colNineTitle="Status"
                                colNineData="StatusKet"
                                
                                colTwoData="JRID"
                                colTwoTitle="No. Job Request"
                                fetching={jobRequest.isGetFetching}
                                modal={handleModal}
                            />
                        </div>
                    </div>
                </div>

            </div>

        )
    }

}


export default JobRequestOperasionalPage;